

















































































































import { Container, ContingentTable } from "@/components";
import LayoutDefault from "../layouts/LayoutDefault.vue";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import ContingentParams from "@/types/contingent-query-params";
import { Actions, Getters } from "@/store";
import { formatCurrency } from "@/utils";
import { Federation } from "@/models/Federation";
import ErrorLabel from "../components/ErrorLabel.vue";

export default Vue.extend({
  name: "ContingentOffset",
  components: {
    Container,
    ContingentTable,
    LayoutDefault,
    ErrorLabel,
  },
  data() {
    return {
      failedToFindContingent: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters([Getters.OPEN_CONTINGENT, Getters.ASSOCIATIONS]),
  },
  mounted() {
    if (this.isValidQueryParameters()) {
      this.loadContingent();
    }
  },
  methods: {
    ...mapActions([Actions.GET_CONTINGENT]),
    isValidQueryParameters(): boolean {
      const { nhonr, year } = this.$route.query;
      const isValid =
        nhonr !== null &&
        typeof nhonr === "string" &&
        year !== null &&
        typeof year === "string";
      return isValid;
    },
    getQueryParameters(): ContingentParams {
      const { nhonr, year } = this.$route.query;

      return {
        nhonr: nhonr !== null && typeof nhonr === "string" ? nhonr : "",
        year: year !== null && typeof year === "string" ? year : "",
      };
    },
    getInvalidQueryMessage(): string {
      const { nhonr, year } = this.$route.query;

      return `Finner ikke beregning for

      NHOnr = ${nhonr}
      År = ${year}

      1. Sjekk at urlen slutter på /contingent?nhonr=NHONR&year=ÅR
      2. Oppdater siden`;
    },
    loadContingent(): void {
      const { nhonr, year } = this.getQueryParameters();

      this.getContingent({ nhoNumber: nhonr, year });
    },
    getNameFromNumber(nhoNumber: number): string {
      const item: Federation = this.associations.find(
        (org: Federation) => org.nhoNumber === nhoNumber
      );
      return item?.name ?? "?";
    },
    getAssociationsText(nhoNumbers: number[]): string {
      return [...new Set(nhoNumbers)]
        .map(
          (nhoNumber) => `${nhoNumber} (${this.getNameFromNumber(nhoNumber)})`
        )
        .join(", ");
    },
    convertToCurrency(num: number, hideCurrencyLabel = false): string {
      return formatCurrency(num, hideCurrencyLabel);
    },
    getPrettyObjectString(object: any): string {
      return JSON.stringify(object, undefined, 2);
    },
  },
});
